<template>
  <b-form-group
    label="Miktar"
    label-for="id_portion_types"
  >
    <validation-provider
      #default="{ errors }"
      name="Miktar"
      rules="required"
    >
      <b-input-group>
        <b-form-input
          v-model="dataList[keyNumber].value"
          placeholder="Miktar"
        />
        <b-input-group-append class="append-width">
          <v-select
            id="id_portion_types"
            v-model="dataList[keyNumber].id_portion_types"
            class="w-100 portion-select"
            label="title"
            :options="portionTypes"
            :reduce="item => item.id"
            placeholder="Seçiniz"
            :clearable="false"
          />
        </b-input-group-append>
      </b-input-group>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BInputGroup, BInputGroupAppend, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'PortionTypeSelect',
  components: {
    BFormGroup,
    vSelect,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    ValidationProvider,
  },
  props: {
    keyNumber: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      locale: 'tr',
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['productPortions/dataList']
    },
    portionTypes() {
      return this.$store.getters['portionTypes/dataList']
    },
  },
  created() {
    localize(this.locale)
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('portionTypes/getDataList')
    },
  },
}
</script>

<style>
.append-width{
  width: 140px !important;
}
.portion-select .vs__dropdown-toggle {
  border-radius: 0 !important;
  border-top-right-radius: 0.357rem !important;
  border-bottom-right-radius: 0.357rem !important;
}
</style>
